/**
 * Shortnames for celebrity demo users used to link UI persona selection to backend user data.
 *
 * Flow:
 * 1. Frontend: User selects a persona from PERSONAS (client/src/App/routes/GenerateComments/personas.ts)
 *    which uses these shortnames as keys
 * 2. Frontend → Backend: The shortname is sent as the `persona` parameter to generateComments()
 * 3. Backend: DEMO_USERS (demoUsers.ts) entries with matching `shortname` field are looked up
 *    to get the full user data (userId, name, persona prompt, etc.)
 *
 * Exported to SDK for client consumption.
 */
export const CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES = {
  DAUBREY: "moody_artist",
  NUPAUL: "nupaul",
  KLEZRA: "klezra",
  LAYNE_ZO: "commentator",
  GIFS: "gifs",
  NOPRAH: "noprah",
  LENDRICK: "lendrick",
} as const;
